<article class="nCash-wrapper">
    <section class="img-wrapper">
        <img src="../../../../../assets/gif/finzy-flex/nCash.svg" alt="nCashImage" loading="lazy" class="image">
    </section>
    <section class="details-wrapper">
        <div class="topic-label">
            <div class="nCash-topic">nCash</div>
        </div>
        <div class="heading-wrapper">
            <h1 class="header-text">Unique custom cashflow options!</h1>
            <span class="header-description">Our nCash feature provides you with multiple options to withdraw a fixed or a customized amount periodically from your investments.</span>
        </div>
        <div class="feature-list">
            <div *ngFor="let i of nCashFeatureList;" class="feature-label">
                <img src="../../../../../assets/images/finzy-flex-dashboard/check-mark.png" alt="check-mark" class="check-img">
                <div class="feature-text-wrap">
                    <span class="text-wrap">{{i}}</span>
                </div>
            </div>
            <div class="know-more">
                <button (click)="onClickKnowMore()" class="btn-outline">
                    Know More
                </button>
            </div>
        </div>
    </section>
</article>
<section class="nCash-feature">
    <div class="feature-list">
        <div class="feature-wrap">
            <div *ngFor="let i of nCashFeatureList;" class="feature-label">
                <img src="../../../../../assets/images/finzy-flex-dashboard/check-mark.png" alt="check-mark" class="check-img">
                <div class="feature-text-wrap">
                    <span class="text-wrap">{{i}}</span>
                </div>
            </div>
        </div>
        <div class="know-more">
            <button (click)="onClickKnowMore()" class="btn-outline">
                Know More
            </button>
        </div>
    </div>
</section>